export default __webpack_public_path__ + "static/media/spaceman.ae336bee.svg";